import { createFileRoute } from "@tanstack/react-router"

import { LegalVersionPage } from "@/components/content/legal-version-page"
import {
  currentLegalVersion,
  lazyLegalModules,
  loadCurrentLegalVersion,
  resolveLegalVersions,
} from "@/lib/legal-versions"
import { seoMeta } from "@/lib/seo"

const modules = lazyLegalModules(import.meta.glob("../-content/cookies/*.md"))

export const Route = createFileRoute("/_content/cookies/")({
  head: () =>
    seoMeta({
      title: "Cookie Policy",
      description: "How Entire uses cookies and similar technologies.",
      url: "https://entire.com/cookies",
      image: "https://entire.com/og/page/cookies.png",
    }),
  loader: () => loadCurrentLegalVersion(modules),
  component: CookiePolicyPage,
})

function CookiePolicyPage() {
  const { asOf } = Route.useLoaderData()
  const versions = resolveLegalVersions(modules, asOf)
  const current = currentLegalVersion(versions)!
  return <LegalVersionPage basePath="/cookies" version={current} versions={versions} />
}
